var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRightArrowTemplate = function SvgIconRightArrowTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#DA613A",
    rx: 22,
    transform: "matrix(-1 0 0 1 44 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.25 14.793a1 1 0 0 0 0 1.414L24.043 22l-5.793 5.793a1 1 0 0 0 1.414 1.414l5.793-5.793a2 2 0 0 0 0-2.828l-5.793-5.793a1 1 0 0 0-1.414 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconRightArrowTemplate;